import React, { useState, useEffect, useRef } from 'react';
import Image from "next/image";
import Link from 'next/link';
import logoeasycampus from "../../public/images/logo-easycampus.png";
import latestcardimg1 from "../../public/images/blog1.jpg";
import latestcardimg2 from "/public/images/blog2.jpg";
import { motion } from "framer-motion";
import { truncateFiftyText, truncateText } from '@/utils/constant';
import { getBlogDataApi } from '../action/easycampus';
import { capitalizeFirstLetter, dateFormatForUser, decodeHtmltoNormal, timeFormatForUser } from '@/utils/common';
import { usePathname } from 'next/navigation';
import { LastBlogDetails, ShortBlogDetails } from '../common/loaderasdata';

const latestarticaltitle = ({ count }) => {
  const [currentDate, setCurrentDate] = useState('');
  const [currentTime, setCurrentTime] = useState('');
  const [blogs, setBlogs] = useState([]);
  const currentRoute = usePathname("");
  let lastSegment = currentRoute.split("/").pop();
  const [isLoading, setIsLoading] = useState(true);
  
  function truncateHtml(html, maxLength) {
    if (typeof window === "undefined") {
      // If running on the server, return the plain HTML as is or handle it differently
     // return html.substring(0, maxLength) || "";
     return html;
      
    }
  
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    let truncated = "";
    let charCount = 0;
  
    const traverseNodes = (node) => {
      if (charCount >= maxLength) return;
  
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent;
        if (charCount + text.length > maxLength) {
          truncated += text.substring(0, maxLength - charCount);
          charCount = maxLength;
        } else {
          truncated += text;
          charCount += text.length;
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        truncated += `<${node.tagName.toLowerCase()}${
          node.getAttribute("style")
            ? ` style="${node.getAttribute("style")}"`
            : ""
        }>`;
        for (let i = 0; i < node.childNodes.length; i++) {
          traverseNodes(node.childNodes[i]);
          if (charCount >= maxLength) break;
        }
        truncated += `</${node.tagName.toLowerCase()}>`;
      }
    };
  
    for (let i = 0; i < tempDiv.childNodes.length; i++) {
      traverseNodes(tempDiv.childNodes[i]);
      if (charCount >= maxLength) break;
    }
  
    return truncated;
  }
  const decodeHtml = (html) => {
    if (typeof window !== "undefined") {
      const txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    }
    // Return the input as is if running on the server
    return html;
  };

  function getWordCountFromHTMLAndCalculateReadTime(htmlContent) {
    // Create a temporary div element to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;
  
    // Extract the text from the div (this removes all the tags)
    const text = tempDiv.innerText || tempDiv.textContent;
  
    // Split the text into words, filter out any empty strings, and count the words
    const words = text.trim().split(/\s+/).filter(word => word.length > 0);
  
    const wordsPerMinute = 200; // Average reading speed
      const minutes = Math.ceil(words.length / wordsPerMinute); // Round up to nearest minute
      return `-${minutes} min`;
  
    // return words.length;
  }
  

  useEffect(() => {
    // Fetch blogs once on component mount
    getBlogs();
  
    // const updateDateTime = () => {
    //   const now = new Date();
    //   const month = now.toLocaleString('default', { month: 'short' });
    //   const day = now.getDate();
    //   const year = now.getFullYear();
    //   const hours = now.getHours();
    //   const minutes = now.getMinutes().toString().padStart(2, '0'); // Add leading zero
    //   const seconds = now.getSeconds().toString().padStart(2, '0'); // Add leading zero
  
    //   setCurrentDate(`${month} ${day}, ${year}`);
    //   setCurrentTime(`${hours}:${minutes}:${seconds}`);
    // };
  
    // // Set up interval to update date and time
    // const intervalId = setInterval(updateDateTime, 1000);
  
    // // Cleanup on component unmount
    // return () => clearInterval(intervalId);
  }, []);
  

  

  const getBlogs = async () => {
    try {
    
      let blogData ={
        pageNo:1,
        pageSize:lastSegment==='blogs'?20:3
      }

      const response = await getBlogDataApi(blogData);
      if (response.data.hasError == false) {
        setBlogs(response.data.data);
        console.log("setCorporateCampusDetails", response.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  

  let style;
  switch (count) {
    case 2:
      style = ""
      break;
    case 3:
      style = "2xl:mx-24 xl:mx-20 lg:mx-20 md:mx-20 sm:mx-10 mx-5"
      break;

    default:
      break;
  }

  const data = [
    {
      bannerImg: latestcardimg1,
      image: logoeasycampus,
      name: "Easy Campus",
      dateTime: currentDate,
      time: "At 9PM",
      heading: "HR in the 21st Century: New Challenges, New Solutions",
      title: " HR in the twenty-first century must be adaptable and adaptable to changing work habits. HR departments in the new ...",
      time1: "-2min Read",
      url: "/blogs/readmoreblogs/hr-in-the-21st-century-new-challenges-new-solutions"
      // url: "/blogs"
    },
    {
      bannerImg: latestcardimg2,
      image: logoeasycampus,
      name: "Easy Campus",
      dateTime: currentDate,
      time: "At 10PM",
      heading: " How to Improve Your HR Management Skills?",
      title: " Every business faces difficulties in finding and keeping qualified staff. This procedure relies heavily on effective...",
      time1: "-5min Read",
      url: "/blogs/readmoreblogs/how-to-improve-your-hr-management-skills"
    },
    {
      bannerImg: latestcardimg1,
      image: logoeasycampus,
      name: "Easy Campus",
      dateTime: currentDate,
      time: "at 7PM",
      heading: "The Ultimate Guide to Recruit the Best Employees in Your Organization",
      title: " The employment of the proper people is critical to any company's success...",
      time1: "-3min Read",
      url: "blogs/readmoreblogs/the-ultimate-guide-to-recruit-the-best-employees-in-your-organization"
    }
  ]

  return (
    <>

   
      <div className={`flex justify-center  mt-8  ${style}`}>
        <div className="grid gap-6 grid-cols-1 lg:grid-cols-12">
          {blogs.map((item,index) => (
            <div key={index} className="col-span-1 lg:col-span-4">
            <Link  href={`/blog/${item.blogUrl}`}>
                <motion.div
                  initial={{ opacity: 0, scale: 0.5 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5 }}>
                  <Image src={item?.blogImageUrl} alt="virtual campus hiring"   width={280} height={398} className="w-full rounded-t-[30px]" />
                </motion.div>
                <div className="bg-[#fff] px-8 py-8 rounded-b-[36px] border-b-4 shadow-lg border-b-[#1e336a]">
                  <motion.div
                    initial={{ y: -100, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{
                      delay: 0.4,
                      y: { type: "spring", stiffness: 60 },
                      opacity: { duration: 1 },
                      ease: "easeIn",
                      duration: 1
                    }}
                    className="mb-3"
                  >
                    <div className="flex justify-start items-start">
                      <Image src={logoeasycampus} alt="campus recruitment"  className="w-12 h-12" />
                      <div className="text-left mt-2 ml-[4px]">
                        <h5 className='text-[14px] font-normal ml-[2px]'>{'Easy Campus'}</h5>
                        <h5 className='text-[14px] font-normal'>
                          <span>{dateFormatForUser(item?.created_at)}</span><span></span></h5>
                      </div>
                    </div>
                  </motion.div>
                  <motion.h4
                    initial={{ y: -100, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{
                      delay: 0.6,
                      y: {
                        type: "spring",
                        stiffness: 60
                      },
                      opacity: { duration: 1 },
                      ease: "easeIn", duration: 1
                    }}
                    className={`${count == 2 ? "mb-4 truncate  tracking-tight text-[#1e336a] text-xl" : "mb-4 truncate tracking-tight text-[#1e336a]"}`}>
                    {capitalizeFirstLetter(item?.blogTitle)}
                  </motion.h4>
                  <motion.p
                    initial={{ y: -100, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{
                      delay: 0.8,
                      y: {
                        type: "spring",
                        stiffness: 60
                      },
                      opacity: { duration: 1 },
                      ease: "easeIn", duration: 1
                    }}
                    className={`${count == 2 ? "text-gray-500 font-medium text-base my-2" : "text-black font-medium my-2"}`}>
                   
                    {/* {count === 2 ? (
                      <>
                        {decodeHtml(item.blogDescription?.length) > 50
                          ? `${(
                            truncateFiftyText(decodeHtml(item.blogDescription))
                          )}...`
                          : (decodeHtml(item.blogDescription)) || " "}
                       
                      </>
                    ) : (
                      <>
                        {decodeHtml(item.blogDescription?.length) > 70
                          ? `${(
                            truncateText(decodeHtml(item.blogDescription))
                          )}...`
                          : (decodeHtml(item.blogDescription)) || " "}

                      </>
                    )} */}
                    <div className=' font-semibold'
                          dangerouslySetInnerHTML={{
                            __html: capitalizeFirstLetter(truncateHtml(
                              decodeHtml(item?.blogDescription),
                              100
                            )),
                          }}
                        />
                  </motion.p>
               
                  <div>
                    <div className="flex items-center">
                      <div className=''>{getWordCountFromHTMLAndCalculateReadTime(item.blogDescription)}, {timeFormatForUser(item?.created_at)}</div>
                      <div className="ml-auto">
                        <button className='cardbtnread btn-1 '>Read More</button>
                      </div>
                    </div>
                  </div>
                 

                </div>
            </Link>
            </div>
          ))}
        </div>
      </div>

    </>
  )
}

export default latestarticaltitle